/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var a;!function(a){a[a.FadeIn=0]="FadeIn",a[a.FadeOut=1]="FadeOut"}(a||(a={}));export{a as FadeDirection};
